import { APP_STORE_IOS_URL } from "@/lib/config"

interface AppStoreButtonProps {
  className?: string
}

export const AppStoreButton = ({ className = "" }: AppStoreButtonProps) => {
  const iosUrl = APP_STORE_IOS_URL

  if (!iosUrl) return null

  return (
    <a
      href={iosUrl}
      className={`inline-block transition-opacity hover:opacity-80 ${className}`}
      aria-label="Download on the App Store"
    >
      <img
        src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1698883200"
        alt="Download on the App Store"
        className="h-11"
      />
    </a>
  )
}
